// extracted by mini-css-extract-plugin
export default {"highlighted":"jhDHP","copy":"R8eYo"};